import { render, staticRenderFns } from "./picker_text.vue?vue&type=template&id=564a088d&"
import script from "./picker_text.vue?vue&type=script&lang=js&"
export * from "./picker_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports